/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { DefaultAngularLand } from 'src/app/common/fancy-firebase/util/default-angular-land.service';
import { FirebaseListFactory } from 'src/app/common/fancy-firebase/services/factories';
import { FancyFragmenterFactory } from 'src/app/common/fancy-firebase/base/FancyFragmenter';
import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyFirebaseList } from 'src/app/common/fancy-firebase/base/FancyFirebaseList';
import { FancyIdJoin } from 'src/app/common/fancy-firebase/base/FancyIdJoin';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';
import { OrganizationsApi } from 'src/app/app-data/state/OrganizationsApi';
import { OrganizationMemberList } from 'src/app/common/fancy-firebase/lists/OrganizationMemberList';
import { OrganizationMembersApi } from 'src/app/app-data/state/OrganizationMembersApi';

import firebase from 'firebase/compat/app';

@Injectable({
	providedIn: 'root',
})
export class FancyFirebaseOrganizationMembersApiBuilder {
	constructor(
		private defaultAngularLand: DefaultAngularLand,
		private fancyFragmenterFactory: FancyFragmenterFactory,
		private firebaseListFactory: FirebaseListFactory
	) {}

	public getOrganizationMembersApi(organizationId: string, organizationsApi: OrganizationsApi) {
		const angularLand = this.defaultAngularLand;
		const usersPath = fancyFirebaseGetters.getUsersPath();
		const userListFragment = this.fancyFragmenterFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(usersPath)
		);
		const userList = new FancyFirebaseList(angularLand, userListFragment.emitter$, FancyAction);
		userListFragment.start();
		const usersJoiner = new FancyIdJoin('userId', userList, userListFragment);

		const organizationJoiner = new FancyIdJoin('organizationId', organizationsApi.data);

		const organizationMemberListPath = fancyFirebaseGetters.getOrganizationMembersPath(organizationId);
		const organizationMemberList = this.firebaseListFactory.create(
			OrganizationMemberList,
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(
				organizationMemberListPath,
				organizationId
			),
			[organizationJoiner, usersJoiner]
		);

		const organizationMembersApi = new OrganizationMembersApi(organizationMemberList);

		organizationMembersApi.addDestroyer(
			() => organizationJoiner.destroy(),
			() => usersJoiner.destroy(),
			() => userListFragment.destroy(),
			() => userList.destroy(),
			() => usersJoiner.destroy()
		);

		return organizationMembersApi;
	}
}
